import { useMutation, useQueryClient } from '@tanstack/react-query';
import { strapiDeleteCustomer } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useDeleteCustomerMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (documentId: string) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiDeleteCustomer(jwt, documentId);
    },
    onSuccess: async (_, documentId) => {
      await qc.invalidateQueries({ queryKey: queryKeys.customersListPrefix(jwt) });
      qc.removeQueries({ queryKey: queryKeys.customerDetail(jwt, documentId) });
    },
  });
}
